// product-claim
const Listproductclaim = () => import('@/views/product-claim')
const Detailproductclaim = () => import('@/views/product-claim/detail')

export default {
    path: 'product-claim',
    redirect: '/product-claim',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'product-claim',
            component: Listproductclaim,
            meta: {
                link: 'product-claim',
                breadcrumb: [
                    { title: 'Product Claim', active: true },
                ],
                pageTitle: 'Product Claim'
            },
        },{
          path: ':id',
          name: 'detailproductclaim',
          component: Detailproductclaim,
          meta: {
              link: 'product-claim',
              breadcrumb: [
                  { title: 'Product Claim', url: '/product-claim' },
                  { title: 'Detail', active: true },
              ],
              pageTitle: 'Product Claim'
          },
      },
    ]
}